import { createReducer, on } from '@ngrx/store';
import * as shopActions from '../actions/shop.action';
import * as utility from '../../../utility';
import { ShopData } from '../../models';

export interface ShopState {
  shopData: ShopData;
  loaded: boolean;
  loading: boolean;
  errors?: any;
}

export const initialState: ShopState = {
  shopData: {},
  loaded: false,
  loading: false,
};

export const ShopReducer = createReducer(
  initialState,
  on(shopActions.LoadShopData, (state: ShopState) => {
    return {
      ...state,
      loading: true,
      errors: undefined,
    };
  }),
  on(shopActions.LoadShopDataSuccess, (state: ShopState, { data }) => {
    return {
      ...state,
      shopData: data,
      loaded: true,
      loading: false,
      errors: undefined,
    };
  }),
  on(shopActions.LoadShopDataFail, (state: ShopState, { errors }) => {
    return {
      ...state,
      shopData: {},
      loaded: false,
      loading: false,
      errors,
    };
  })
);

export const getShipsToCountries = (state: ShopState) => state.shopData?.shipsToCountries;
export const getShopDataLoading = (state: ShopState) => state.loading;
export const getShopDataLoaded = (state: ShopState) => state.loaded;
